import { IGetFaireDirectBrandsForVisitorResponse } from "@faire/web-api--source/indigofair/brand/direct/IGetFaireDirectBrandsForVisitorResponse";

import { BrandTokenOrBrandAlias } from "../faireDirectTypes";

export const getFaireDirectBrandFromTokenOrAlias = (
  params: BrandTokenOrBrandAlias,
  faireDirectBrandsForVisitor:
    | IGetFaireDirectBrandsForVisitorResponse.IFaireDirectBrand[]
    | undefined
): IGetFaireDirectBrandsForVisitorResponse.IFaireDirectBrand | undefined => {
  if (!faireDirectBrandsForVisitor || !params) {
    return undefined;
  }

  const { brandToken, brandAlias } = params;

  return faireDirectBrandsForVisitor?.find(
    (brand) =>
      brand.brand_token_alias === brandAlias || brand.brand_token === brandToken
  );
};
